(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("prop-types"), require("@algolia/autocomplete-js"), require("algoliasearch"), require("@algolia/autocomplete-plugin-algolia-insights"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "prop-types", "@algolia/autocomplete-js", "algoliasearch", "@algolia/autocomplete-plugin-algolia-insights", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["Autocomplete"] = factory(require("react"), require("prop-types"), require("@algolia/autocomplete-js"), require("algoliasearch"), require("@algolia/autocomplete-plugin-algolia-insights"), require("react-dom"));
	else
		root["Autocomplete"] = factory(root["react"], root["prop-types"], root["@algolia/autocomplete-js"], root["algoliasearch"], root["@algolia/autocomplete-plugin-algolia-insights"], root["react-dom"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__5__, __WEBPACK_EXTERNAL_MODULE__21__, __WEBPACK_EXTERNAL_MODULE__22__, __WEBPACK_EXTERNAL_MODULE__23__, __WEBPACK_EXTERNAL_MODULE__24__) {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ([
/* 0 */,
/* 1 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Autocomplete)
/* harmony export */ });
/* harmony import */ var _assets_search_by_algolia_light_background_svg__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _Preview__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var algoliasearch__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22);
/* harmony import */ var algoliasearch__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(algoliasearch__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _algolia_autocomplete_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21);
/* harmony import */ var _algolia_autocomplete_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_algolia_autocomplete_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _algolia_autocomplete_plugin_algolia_insights__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23);
/* harmony import */ var _algolia_autocomplete_plugin_algolia_insights__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_algolia_autocomplete_plugin_algolia_insights__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(24);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_8__);
var _excluded = ["appId", "apiKey", "currentSource", "optionalFilters", "sources", "inputPlaceholder", "returnFocusOnClose", "isExternal"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }









 // need to inject autocomplete styles in html head
// <link
//   rel="stylesheet"
//   href="https://cdn.jsdelivr.net/npm/@algolia/autocomplete-theme-classic"
// />
// overriding autocomplete-theme-classic
// https://www.algolia.com/doc/ui-libraries/autocomplete/api-reference/autocomplete-theme-classic/

var defaultSources = {
  docs: {
    headerTitle: 'Documentation'
  },
  blog: {
    headerTitle: 'Blog'
  },
  odyssey: {
    headerTitle: 'Odyssey',
    transformResponse: function transformResponse(_ref) {
      var hits = _ref.hits;
      // exclude internal Odyssey courses
      return hits[0].filter(function (hit) {
        return !hit.categories.includes('internal');
      });
    }
  },
  graphql_com: {
    headerTitle: 'GraphQL.com'
  }
};

var _getSources = function getSources(_ref2) {
  var searchClient = _ref2.searchClient,
      sourcesObj = _ref2.sourcesObj,
      optionalFilters = _ref2.optionalFilters,
      currentSource = _ref2.currentSource,
      isExternal = _ref2.isExternal;
  var sortedSources = currentSource ? Object.entries(sourcesObj).sort(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 1),
        a = _ref4[0];

    return a === currentSource ? -1 : 1;
  }) : Object.entries(sourcesObj);
  var sourcesArray = sortedSources.map(function (_ref5, index) {
    var _ref6 = _slicedToArray(_ref5, 2),
        sourceKey = _ref6[0],
        sourceOptions = _ref6[1];

    return (0,_utils__WEBPACK_IMPORTED_MODULE_7__.generateSource)(_objectSpread({
      isTopSource: index === 0,
      searchClient: searchClient,
      sourceId: sourceKey,
      indexName: sourceKey,
      hitsPerPage: index > 0 ? 2 : undefined,
      // only show 2 hits for sites that aren't the first source
      optionalFilters: optionalFilters,
      isExternal: isExternal
    }, sourceOptions));
  });
  return [].concat(_toConsumableArray(sourcesArray), [(0,_utils__WEBPACK_IMPORTED_MODULE_7__.generateSource)({
    searchClient: searchClient,
    sourceId: 'suggestions',
    indexName: 'docs_query_suggestions',
    hitsPerPage: 4,
    isQuerySuggestion: true
  })]);
};

function Autocomplete(_ref7) {
  var appId = _ref7.appId,
      apiKey = _ref7.apiKey,
      currentSource = _ref7.currentSource,
      optionalFilters = _ref7.optionalFilters,
      sources = _ref7.sources,
      inputPlaceholder = _ref7.inputPlaceholder,
      returnFocusOnClose = _ref7.returnFocusOnClose,
      isExternal = _ref7.isExternal,
      props = _objectWithoutProperties(_ref7, _excluded);

  var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)();
  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function () {
    var searchClient = algoliasearch__WEBPACK_IMPORTED_MODULE_4___default()(appId, apiKey); // https://github.com/algolia/search-insights.js#browser

    var ALGOLIA_INSIGHTS_SRC = 'https://cdn.jsdelivr.net/npm/search-insights@2.0.3';
    !function (e, a, t, n, s, i, c) {
      e.AlgoliaAnalyticsObject = s, e[s] = e[s] || function () {
        (e[s].queue = e[s].queue || []).push(arguments);
      }, i = a.createElement(t), c = a.getElementsByTagName(t)[0], i.async = 1, i.src = n, c.parentNode.insertBefore(i, c);
    }(window, document, 'script', ALGOLIA_INSIGHTS_SRC, 'aa');
    window.aa('init', {
      appId: appId,
      apiKey: apiKey,
      useCookie: true
    });
    var algoliaInsightsPlugin = (0,_algolia_autocomplete_plugin_algolia_insights__WEBPACK_IMPORTED_MODULE_6__.createAlgoliaInsightsPlugin)({
      insightsClient: window.aa,
      onSelect: function onSelect(_ref8) {
        var insights = _ref8.insights,
            insightsEvents = _ref8.insightsEvents;
        var events = insightsEvents.map(function (insightsEvent) {
          switch (insightsEvent.index) {
            case 'docs_query_suggestions':
              {
                return _objectSpread(_objectSpread({}, insightsEvent), {}, {
                  eventName: 'Suggestion selected from Autocomplete'
                });
              }

            case 'docs':
              {
                return _objectSpread(_objectSpread({}, insightsEvent), {}, {
                  eventName: 'Article selected from docs index'
                });
              }

            default:
              {
                return _objectSpread(_objectSpread({}, insightsEvent), {}, {
                  eventName: 'Article selected from Autocomplete'
                });
              }
          }
        });
        insights.clickedObjectIDsAfterSearch.apply(insights, _toConsumableArray(events));
      }
    });
    var search = (0,_algolia_autocomplete_js__WEBPACK_IMPORTED_MODULE_5__.autocomplete)(_objectSpread({
      placeholder: inputPlaceholder !== null && inputPlaceholder !== void 0 ? inputPlaceholder : 'What do you want to learn about GraphQL?',
      debug: true,
      openOnFocus: true,
      detachedMediaQuery: '',
      defaultActiveItemId: 0,
      container: containerRef.current,
      plugins: [algoliaInsightsPlugin],
      renderer: {
        createElement: react__WEBPACK_IMPORTED_MODULE_3__.createElement,
        Fragment: react__WEBPACK_IMPORTED_MODULE_3__.Fragment
      },
      onStateChange: function onStateChange(event) {
        var prevState = event.prevState,
            state = event.state;

        if (returnFocusOnClose && prevState.isOpen && !state.isOpen) {
          var autocompleteBtn = document.querySelector('.aa-DetachedSearchButton');
          setTimeout(function () {
            return autocompleteBtn.focus();
          });
        }
      },
      render: function render(_ref9, root) {
        var children = _ref9.children,
            state = _ref9.state,
            components = _ref9.components;
        var preview = state.context.preview;
        var icon = preview ? preview.type !== 'docs' ? preview.type : preview.docset : null; // don't show the preview if the query didn't pull up any results

        var hasResults = state.collections.find(function (source) {
          return source.items.length;
        });

        (0,react_dom__WEBPACK_IMPORTED_MODULE_8__.render)( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", {
          className: "aa-Container"
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", {
          className: "aa-Grid"
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", {
          className: "aa-Results aa-Column ".concat(!hasResults ? 'aa-NoResults' : '')
        }, children), preview && hasResults && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement(_Preview__WEBPACK_IMPORTED_MODULE_1__["default"], {
          preview: preview,
          components: components,
          icon: icon,
          search: search
        })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("a", {
          href: "https://algolia.com/",
          className: "aa-AlgoliaAttribution"
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement(_assets_search_by_algolia_light_background_svg__WEBPACK_IMPORTED_MODULE_0__["default"], null))), root);
      },
      getSources: function getSources() {
        return _getSources({
          searchClient: searchClient,
          optionalFilters: optionalFilters,
          sourcesObj: _objectSpread(_objectSpread({}, defaultSources), sources),
          currentSource: currentSource,
          isExternal: isExternal
        });
      }
    }, props));
    return function () {
      search.destroy();
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // open autocomplete on keypress `/`

  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function () {
    var handleKeyDown = function handleKeyDown(e) {
      if (e.key === '/') {
        document.querySelector('.aa-DetachedSearchButton').click();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return function () {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", {
    ref: containerRef,
    className: "autocomplete-container"
  });
}
Autocomplete.propTypes = {
  currentSource: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  appId: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired),
  apiKey: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired),
  optionalFilters: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().array),
  sources: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().object),
  inputPlaceholder: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  returnFocusOnClose: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  isExternal: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool)
};

/***/ }),
/* 2 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgSearchByAlgoliaLightBackground(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 168 24"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#5468FF",
    d: "M78.988.938h16.594a2.968 2.968 0 012.966 2.966V20.5a2.967 2.967 0 01-2.966 2.964H78.988a2.967 2.967 0 01-2.966-2.964V3.897A2.961 2.961 0 0178.988.938zm41.937 17.866c-4.386.02-4.386-3.54-4.386-4.106l-.007-13.336 2.675-.424v13.254c0 .322 0 2.358 1.718 2.364v2.248zm-10.846-2.18c.821 0 1.43-.047 1.855-.129v-2.719a6.334 6.334 0 00-1.574-.199 5.7 5.7 0 00-.897.069 2.699 2.699 0 00-.814.24c-.24.116-.439.28-.582.491-.15.212-.219.335-.219.656 0 .628.219.991.616 1.23s.938.362 1.615.362zm-.233-9.7c.883 0 1.629.109 2.231.328.602.218 1.088.525 1.444.915.363.396.609.922.76 1.483.157.56.232 1.175.232 1.85v6.874a32.5 32.5 0 01-1.868.314c-.834.123-1.772.185-2.813.185-.69 0-1.327-.069-1.895-.198a4.001 4.001 0 01-1.471-.636 3.085 3.085 0 01-.951-1.134c-.226-.465-.343-1.12-.343-1.803 0-.656.13-1.073.384-1.525a3.24 3.24 0 011.047-1.106c.445-.287.95-.492 1.532-.615a8.8 8.8 0 011.82-.185 8.404 8.404 0 011.972.24v-.438c0-.307-.035-.6-.11-.874a1.88 1.88 0 00-.384-.73 1.784 1.784 0 00-.724-.493 3.164 3.164 0 00-1.143-.205c-.616 0-1.177.075-1.69.164a7.735 7.735 0 00-1.26.307l-.321-2.192c.335-.117.834-.233 1.478-.349a10.98 10.98 0 012.073-.178zm52.842 9.626c.822 0 1.43-.048 1.854-.13V13.7a6.347 6.347 0 00-1.574-.199c-.294 0-.595.021-.896.069a2.7 2.7 0 00-.814.24 1.46 1.46 0 00-.582.491c-.15.212-.218.335-.218.656 0 .628.218.991.615 1.23.404.245.938.362 1.615.362zm-.226-9.694c.883 0 1.629.108 2.231.327.602.219 1.088.526 1.444.915.355.39.609.923.759 1.483a6.8 6.8 0 01.233 1.852v6.873c-.41.088-1.034.19-1.868.314-.834.123-1.772.184-2.813.184-.69 0-1.327-.068-1.895-.198a4.001 4.001 0 01-1.471-.635 3.085 3.085 0 01-.951-1.134c-.226-.465-.343-1.12-.343-1.804 0-.656.13-1.073.384-1.524.26-.45.608-.82 1.047-1.107.445-.286.95-.491 1.532-.614a8.803 8.803 0 012.751-.13c.329.034.671.096 1.04.185v-.437a3.3 3.3 0 00-.109-.875 1.873 1.873 0 00-.384-.731 1.784 1.784 0 00-.724-.492 3.165 3.165 0 00-1.143-.205c-.616 0-1.177.075-1.69.164a7.75 7.75 0 00-1.26.307l-.321-2.193c.335-.116.834-.232 1.478-.348a11.633 11.633 0 012.073-.177zm-8.034-1.271a1.626 1.626 0 01-1.628-1.62c0-.895.725-1.62 1.628-1.62.904 0 1.63.725 1.63 1.62 0 .895-.733 1.62-1.63 1.62zm1.348 13.22h-2.689V7.27l2.69-.423v11.956zm-4.714 0c-4.386.02-4.386-3.54-4.386-4.107l-.008-13.336 2.676-.424v13.254c0 .322 0 2.358 1.718 2.364v2.248zm-8.698-5.903c0-1.156-.253-2.119-.746-2.788-.493-.677-1.183-1.01-2.067-1.01-.882 0-1.574.333-2.065 1.01-.493.676-.733 1.632-.733 2.788 0 1.168.246 1.953.74 2.63.492.683 1.183 1.018 2.066 1.018.882 0 1.574-.342 2.067-1.019.492-.683.738-1.46.738-2.63zm2.737-.007c0 .902-.13 1.584-.397 2.33a5.52 5.52 0 01-1.128 1.906 4.986 4.986 0 01-1.752 1.223c-.685.286-1.739.45-2.265.45-.528-.006-1.574-.157-2.252-.45a5.096 5.096 0 01-1.744-1.223c-.487-.527-.863-1.162-1.137-1.906a6.345 6.345 0 01-.41-2.33c0-.902.123-1.77.397-2.508a5.554 5.554 0 011.15-1.892 5.133 5.133 0 011.75-1.216c.679-.287 1.425-.423 2.232-.423.808 0 1.553.142 2.237.423a4.88 4.88 0 011.753 1.216 5.644 5.644 0 011.135 1.892c.287.738.431 1.606.431 2.508zm-20.138 0c0 1.12.246 2.363.738 2.882.493.52 1.13.78 1.91.78.424 0 .828-.062 1.204-.178.377-.116.677-.253.917-.417V9.33a10.476 10.476 0 00-1.766-.226c-.971-.028-1.71.37-2.23 1.004-.513.636-.773 1.75-.773 2.788zm7.438 5.274c0 1.824-.466 3.156-1.404 4.004-.936.846-2.367 1.27-4.296 1.27-.705 0-2.17-.137-3.34-.396l.431-2.118c.98.205 2.272.26 2.95.26 1.074 0 1.84-.219 2.299-.656.459-.437.684-1.086.684-1.948v-.437a8.07 8.07 0 01-1.047.397c-.43.13-.93.198-1.492.198-.739 0-1.41-.116-2.018-.349a4.206 4.206 0 01-1.567-1.025c-.431-.45-.774-1.017-1.013-1.694-.24-.677-.363-1.885-.363-2.773 0-.834.13-1.88.384-2.577.26-.696.629-1.298 1.129-1.796.493-.498 1.095-.881 1.8-1.162a6.605 6.605 0 012.428-.457c.87 0 1.67.109 2.45.24.78.129 1.444.265 1.985.415V18.17z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#5D6494",
    d: "M6.972 6.677v1.627c-.712-.446-1.52-.67-2.425-.67-.585 0-1.045.13-1.38.391a1.24 1.24 0 00-.502 1.03c0 .425.164.765.494 1.02.33.256.835.532 1.516.83.447.192.795.356 1.045.495.25.138.537.332.862.582.324.25.563.548.718.894.154.345.23.741.23 1.188 0 .947-.334 1.691-1.004 2.234-.67.542-1.537.814-2.601.814-1.18 0-2.16-.229-2.936-.686v-1.708c.84.628 1.814.942 2.92.942.585 0 1.048-.136 1.388-.407.34-.271.51-.646.51-1.125 0-.287-.1-.55-.302-.79-.203-.24-.42-.42-.655-.542-.234-.123-.585-.29-1.053-.503a61.27 61.27 0 01-.582-.271 13.67 13.67 0 01-.55-.287 4.275 4.275 0 01-.567-.351 6.92 6.92 0 01-.455-.4c-.18-.17-.31-.34-.39-.51-.08-.17-.155-.37-.224-.598a2.553 2.553 0 01-.104-.742c0-.915.333-1.638.998-2.17.664-.532 1.523-.798 2.576-.798.968 0 1.793.17 2.473.51zm7.468 5.696v-.287c-.022-.607-.187-1.088-.495-1.444-.309-.357-.75-.535-1.324-.535-.532 0-.99.194-1.373.583-.382.388-.622.949-.717 1.683h3.909zm1.005 2.792v1.404c-.596.34-1.383.51-2.362.51-1.255 0-2.255-.377-3-1.132-.744-.755-1.116-1.744-1.116-2.968 0-1.297.34-2.316 1.021-3.055.68-.74 1.548-1.11 2.6-1.11 1.033 0 1.852.323 2.458.966.606.644.91 1.572.91 2.784 0 .33-.033.676-.096 1.038h-5.314c.107.702.405 1.239.894 1.611.49.372 1.106.558 1.85.558.862 0 1.58-.202 2.155-.606zm6.605-1.77h-1.212c-.596 0-1.045.116-1.349.35-.303.234-.454.532-.454.894 0 .372.117.664.35.877.235.213.575.32 1.022.32.51 0 .912-.142 1.204-.424.293-.281.44-.651.44-1.108v-.91zm-4.068-2.554V9.325c.627-.361 1.457-.542 2.489-.542 2.116 0 3.175 1.026 3.175 3.08V17h-1.548v-.957c-.415.68-1.143 1.02-2.186 1.02-.766 0-1.38-.22-1.843-.661-.462-.442-.694-1.003-.694-1.684 0-.776.293-1.38.878-1.81.585-.431 1.404-.647 2.457-.647h1.34V11.8c0-.554-.133-.971-.399-1.253-.266-.282-.707-.423-1.324-.423a4.07 4.07 0 00-2.345.718zm9.333-1.93v1.42c.394-1 1.101-1.5 2.123-1.5.148 0 .313.016.494.048v1.531a1.885 1.885 0 00-.75-.143c-.542 0-.989.24-1.34.718-.351.479-.527 1.048-.527 1.707V17h-1.563V8.91h1.563zm5.01 4.084c.022.82.272 1.492.75 2.019.479.526 1.15.79 2.01.79.639 0 1.235-.176 1.788-.527v1.404c-.521.319-1.186.479-1.995.479-1.265 0-2.276-.4-3.031-1.197-.755-.798-1.133-1.792-1.133-2.984 0-1.16.38-2.151 1.14-2.975.761-.825 1.79-1.237 3.088-1.237.702 0 1.346.149 1.93.447v1.436a3.242 3.242 0 00-1.77-.495c-.84 0-1.513.266-2.019.798-.505.532-.758 1.213-.758 2.042zM40.24 5.72v4.579c.458-1 1.293-1.5 2.505-1.5.787 0 1.42.245 1.899.734.479.49.718 1.17.718 2.042V17h-1.564v-5.106c0-.553-.14-.98-.422-1.284-.282-.303-.652-.455-1.11-.455-.531 0-1.002.202-1.411.606-.41.405-.615 1.022-.615 1.851V17h-1.563V5.72h1.563zm14.966 10.02c.596 0 1.096-.253 1.5-.758.404-.506.606-1.157.606-1.955 0-.915-.202-1.62-.606-2.114-.404-.495-.92-.742-1.548-.742-.553 0-1.05.224-1.491.67-.442.447-.662 1.133-.662 2.058 0 .958.212 1.67.638 2.138.425.469.946.703 1.563.703zM53.004 5.72v4.42c.574-.894 1.388-1.341 2.44-1.341 1.022 0 1.857.383 2.506 1.149.649.766.973 1.781.973 3.047 0 1.138-.309 2.109-.925 2.912-.617.803-1.463 1.205-2.537 1.205-1.075 0-1.894-.447-2.457-1.34V17h-1.58V5.72h1.58zm9.908 11.104l-3.223-7.913h1.739l1.005 2.632 1.26 3.415c.096-.32.48-1.458 1.15-3.415l.909-2.632h1.66l-2.92 7.866c-.777 2.074-1.963 3.11-3.559 3.11a2.92 2.92 0 01-.734-.079v-1.34c.17.042.351.064.543.064 1.032 0 1.755-.57 2.17-1.708z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#FFF",
    d: "M89.632 5.967v-.772a.978.978 0 00-.978-.977h-2.28a.978.978 0 00-.978.977v.793c0 .088.082.15.171.13a7.127 7.127 0 011.984-.28c.65 0 1.295.088 1.917.259.082.02.164-.04.164-.13m-6.248 1.01l-.39-.389a.977.977 0 00-1.382 0l-.465.465a.973.973 0 000 1.38l.383.383c.062.061.15.047.205-.014.226-.307.472-.601.746-.874.281-.28.568-.526.883-.751.068-.042.075-.137.02-.2m4.16 2.453v3.341c0 .096.104.165.192.117l2.97-1.537c.068-.034.089-.117.055-.184a3.695 3.695 0 00-3.08-1.866c-.068 0-.136.054-.136.13m0 8.048a4.489 4.489 0 01-4.49-4.482 4.488 4.488 0 014.49-4.482 4.488 4.488 0 014.489 4.482 4.484 4.484 0 01-4.49 4.482m0-10.85a6.363 6.363 0 100 12.729 6.37 6.37 0 006.372-6.368 6.358 6.358 0 00-6.371-6.36"
  }))));
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgSearchByAlgoliaLightBackground);

/***/ }),
/* 3 */
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__3__;

/***/ }),
/* 4 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _DocsetIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18);





var Chevron = function Chevron() {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", {
    className: "aa-Chevron"
  }, "\u276F");
};

var Preview = function Preview(_ref) {
  var _preview$ancestors, _preview$ancestors2, _preview$ancestors3, _preview$categories;

  var preview = _ref.preview,
      components = _ref.components,
      icon = _ref.icon,
      search = _ref.search;
  // feels too busy to have the date rendered, too
  // const postDate = preview.date && new Date(preview.date);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "aa-Preview aa-Column"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "aa-PreviewType"
  }, icon && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement((react__WEBPACK_IMPORTED_MODULE_1___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(_DocsetIcon__WEBPACK_IMPORTED_MODULE_2__.DocsetIcon, {
    docset: icon
  }), preview.docset && (preview.docset === 'ios' ? 'iOS' : preview.docset === 'android' ? 'Kotlin' : preview.docset.split('-').map(_utils__WEBPACK_IMPORTED_MODULE_3__.upperCaseFirstLetter).join(' ')), ' '), preview.type && preview.type === 'graphql_com' ? 'GraphQL.com' : (0,_utils__WEBPACK_IMPORTED_MODULE_3__.upperCaseFirstLetter)(preview.type)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "aa-PreviewTitle"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "aa-PreviewTitleWrapper"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("a", {
    href: preview.url
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(components.Highlight, {
    hit: preview,
    attribute: "title"
  })))), (((_preview$ancestors = preview.ancestors) === null || _preview$ancestors === void 0 ? void 0 : _preview$ancestors.length) || preview.sectionTitle) && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "aa-PreviewBreacrumbs"
  }, (_preview$ancestors2 = preview.ancestors) === null || _preview$ancestors2 === void 0 ? void 0 : _preview$ancestors2.map(function (ancestor, i) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement((react__WEBPACK_IMPORTED_MODULE_1___default().Fragment), null, i > 0 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(Chevron, null), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("a", {
      href: ancestor.url,
      key: ancestor.url,
      className: "aa-PreviewBreadcrumbsContent"
    }, ancestor.title));
  }), preview.sectionTitle && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement((react__WEBPACK_IMPORTED_MODULE_1___default().Fragment), null, ((_preview$ancestors3 = preview.ancestors) === null || _preview$ancestors3 === void 0 ? void 0 : _preview$ancestors3.length) > 0 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(Chevron, null), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("a", {
    href: preview.url,
    className: "aa-PreviewBreadcrumbsContent"
  }, preview.sectionTitle))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "aa-PreviewDescription"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(components.Snippet, {
    hit: preview,
    attribute: preview ? preview.text ? 'text' : 'description' : ''
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "aa-CategoriesContainer"
  }, (_preview$categories = preview.categories) === null || _preview$categories === void 0 ? void 0 : _preview$categories.map(function (category, i) {
    return category !== 'documentation' && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", {
      key: "".concat(preview.title, "-").concat(category, "-").concat(i),
      className: "aa-QuerySuggestion",
      onClick: function onClick() {
        search.setQuery(category);
        search.refresh();
      }
    }, category.replaceAll('-', ' '));
  })));
};

Preview.propTypes = {
  preview: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().object.isRequired),
  components: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().object.isRequired),
  icon: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),
  search: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().object.isRequired)
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Preview);

/***/ }),
/* 5 */
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__5__;

/***/ }),
/* 6 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DocsetIcon": () => (/* binding */ DocsetIcon)
/* harmony export */ });
/* harmony import */ var _assets_apollo_logo_svg__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7);
/* harmony import */ var _assets_apple_logo_svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8);
/* harmony import */ var _assets_book_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9);
/* harmony import */ var _assets_federation_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10);
/* harmony import */ var _assets_graphql_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11);
/* harmony import */ var _assets_kotlin_svg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12);
/* harmony import */ var _assets_odyssey_svg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _assets_react_logo_svg__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(14);
/* harmony import */ var _assets_rover_logo_svg__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(15);
/* harmony import */ var _assets_satellite3_svg__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(16);
/* harmony import */ var _assets_schema_svg__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(17);












 // Reused much of code from apollographql/apollo/docs/source/components/docset-menu.js
// Copied logos from apollographql/apollo/docs/source/assets
// keys match names of docsets in algolia records

var icons = {
  'apollo-client': /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8___default().createElement(_assets_react_logo_svg__WEBPACK_IMPORTED_MODULE_9__["default"], null),
  'apollo-ios': /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8___default().createElement(_assets_apple_logo_svg__WEBPACK_IMPORTED_MODULE_1__["default"], {
    style: {
      paddingBottom: 1
    }
  }),
  'apollo-kotlin': /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8___default().createElement(_assets_kotlin_svg__WEBPACK_IMPORTED_MODULE_5__["default"], null),
  'apollo-server': /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8___default().createElement(_assets_satellite3_svg__WEBPACK_IMPORTED_MODULE_11__["default"], null),
  // TODO: fix stroke-width of satellite icon
  federation: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8___default().createElement(_assets_federation_svg__WEBPACK_IMPORTED_MODULE_3__["default"], null),
  studio: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8___default().createElement(_assets_schema_svg__WEBPACK_IMPORTED_MODULE_12__["default"], null),
  rover: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8___default().createElement(_assets_rover_logo_svg__WEBPACK_IMPORTED_MODULE_10__["default"], null),
  odyssey: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8___default().createElement(_assets_odyssey_svg__WEBPACK_IMPORTED_MODULE_6__["default"], null),
  blog: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8___default().createElement(_assets_book_svg__WEBPACK_IMPORTED_MODULE_2__["default"], null),
  basics: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8___default().createElement(_assets_apollo_logo_svg__WEBPACK_IMPORTED_MODULE_0__["default"], null),
  router: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8___default().createElement(_assets_apollo_logo_svg__WEBPACK_IMPORTED_MODULE_0__["default"], null),
  graphql_com: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8___default().createElement(_assets_graphql_svg__WEBPACK_IMPORTED_MODULE_4__["default"], null)
};
function DocsetIcon(_ref) {
  var docset = _ref.docset;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8___default().createElement("div", {
    className: "aa-DocsetIcon"
  }, icons[docset]);
}
DocsetIcon.propTypes = {
  docset: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string.isRequired)
};

/***/ }),
/* 7 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgApolloLogo(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M112.246 49H88.003L53 139.848h21.927l5.721-15.393h33.076l-5.989-17.024H85.961l14.164-39.091 25.199 71.508h21.928z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M196.313 73.038a4.991 4.991 0 00-.256-.897c-.027-.1-.12-.285-.12-.285a4.993 4.993 0 00-4.538-2.914 5 5 0 00-5 5c0 .562.098 1.1.268 1.603l-.014.005a90.354 90.354 0 013.346 24.451c0 24.039-9.362 46.641-26.359 63.64-16.999 17-39.6 26.36-63.64 26.36-24.039 0-46.642-9.362-63.639-26.36C19.36 146.642 10 124.04 10 100.001c0-24.04 9.362-46.641 26.361-63.64 16.997-17 39.6-26.36 63.639-26.36 21.466 0 41.781 7.47 57.987 21.173a12.218 12.218 0 00-.848 4.474c0 6.751 5.472 12.221 12.224 12.221 6.75 0 12.223-5.47 12.223-12.221s-5.473-12.224-12.223-12.224c-1.473 0-2.884.26-4.192.737C147.666 9.107 124.9 0 100 0 44.771 0 0 44.772 0 100.001c0 55.229 44.771 100.001 100 100.001s100-44.771 100-100.001c0-9.342-1.291-18.384-3.687-26.963z"
  })));
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgApolloLogo);

/***/ }),
/* 8 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgAppleLogo(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 138 162",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M134.37 126.25c-2.45 5.66-5.35 10.87-8.71 15.66-4.58 6.53-8.33 11.05-11.22 13.56-4.48 4.12-9.28 6.23-14.42 6.35-3.69 0-8.14-1.05-13.32-3.18-5.197-2.12-9.973-3.17-14.34-3.17-4.58 0-9.492 1.05-14.746 3.17-5.262 2.13-9.501 3.24-12.742 3.35-4.929.21-9.842-1.96-14.746-6.52-3.13-2.73-7.045-7.41-11.735-14.04-5.032-7.08-9.169-15.29-12.41-24.65C2.51 106.67.77 96.88.77 87.402c0-10.857 2.346-20.221 7.045-28.068 3.693-6.303 8.606-11.275 14.755-14.925 6.149-3.65 12.793-5.51 19.948-5.629 3.915 0 9.049 1.211 15.429 3.591 6.362 2.388 10.447 3.599 12.238 3.599 1.339 0 5.877-1.416 13.57-4.239 7.275-2.618 13.415-3.702 18.445-3.275 13.63 1.1 23.87 6.473 30.68 16.153-12.19 7.386-18.22 17.731-18.1 31.002.11 10.337 3.86 18.939 11.23 25.769 3.34 3.17 7.07 5.62 11.22 7.36-.9 2.61-1.85 5.11-2.86 7.51zM103.11 3.24c0 8.102-2.96 15.667-8.86 22.669-7.12 8.324-15.732 13.134-25.071 12.375a25.222 25.222 0 01-.188-3.07c0-7.778 3.386-16.102 9.399-22.908 3.002-3.446 6.82-6.311 11.45-8.597 4.62-2.252 8.99-3.497 13.1-3.71.12 1.083.17 2.166.17 3.24v.001z"
  })));
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgAppleLogo);

/***/ }),
/* 9 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgBook(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140 140"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M66.838 124.07a9.333 9.333 0 006.33 0 79.683 79.683 0 0150.75-2.614 9.374 9.374 0 0011.701-9.094V28.747a9.374 9.374 0 00-6.533-8.914A80.955 80.955 0 0073.167 21a9.392 9.392 0 01-6.329 0 80.972 80.972 0 00-55.924-1.167 9.374 9.374 0 00-6.539 8.914v83.615a9.374 9.374 0 0011.702 9.094 79.7 79.7 0 0150.761 2.613zM70 21.477v103.145",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8.749995
  })));
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgBook);

/***/ }),
/* 10 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgFederation(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 132 141",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M13.505 110.165c1.016-22.37 19.75-39.759 42.053-39.195l.559.018h19.765l.56-.018c22.078-.558 40.658 16.475 42.017 38.518l.036.677a4.375 4.375 0 01-8.74.397c-.8-17.605-15.543-31.288-33.095-30.845l-.533.018-.181.003H56.054l-.181-.003c-17.786-.737-32.82 13.045-33.628 30.827a4.375 4.375 0 01-8.74-.397z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M66 35.988a4.375 4.375 0 014.37 4.163l.005.212v70a4.375 4.375 0 01-8.745.212l-.005-.212v-70A4.375 4.375 0 0166 35.988z"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M66 .988c-4.47 0-8.627 1.341-12.09 3.642l-.556.382c-5.585 3.963-9.229 10.482-9.229 17.851 0 12.082 9.794 21.875 21.875 21.875s21.875-9.793 21.875-21.875c0-7.37-3.644-13.888-9.229-17.851l-.556-.382A21.773 21.773 0 0066 .988zm0 8.75c7.249 0 13.125 5.877 13.125 13.125 0 7.25-5.876 13.125-13.125 13.125s-13.125-5.876-13.125-13.125c0-7.248 5.876-13.125 13.125-13.125zM17.875 105.988c-9.665 0-17.5 7.835-17.5 17.5s7.835 17.5 17.5 17.5 17.5-7.835 17.5-17.5-7.835-17.5-17.5-17.5zm0 8.75a8.75 8.75 0 110 17.5 8.75 8.75 0 010-17.5zM66 105.988c-9.665 0-17.5 7.835-17.5 17.5s7.835 17.5 17.5 17.5 17.5-7.835 17.5-17.5-7.835-17.5-17.5-17.5zm0 8.75a8.75 8.75 0 110 17.5 8.75 8.75 0 010-17.5zM114.125 105.988c-9.665 0-17.5 7.835-17.5 17.5s7.835 17.5 17.5 17.5 17.5-7.835 17.5-17.5-7.835-17.5-17.5-17.5zm0 8.75a8.75 8.75 0 110 17.5 8.75 8.75 0 010-17.5z"
  })));
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgFederation);

/***/ }),
/* 11 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgGraphql(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 400 400",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M43.092 294.36l14.376 8.3 160.15-277.38-14.376-8.3-160.15 277.38z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M360.1 272.2H39.8v16.6h320.3v-16.6z"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M46.138 281.526l160.21 92.5 8.3-14.376-160.21-92.5-8.3 14.376zM185.312 40.447l160.21 92.5 8.3-14.376-160.21-92.5-8.3 14.376z"
  })), _path4 || (_path4 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M46.182 118.508l8.3 14.375 160.21-92.5-8.3-14.375-160.21 92.5z"
  })), _path5 || (_path5 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M182.418 25.283l160.15 277.38 14.376-8.3-160.15-277.38-14.376 8.3zM69.1 107.5H52.5v185h16.6v-185z"
  })), _path6 || (_path6 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M347.5 107.5h-16.6v185h16.6v-185z"
  })), _path7 || (_path7 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M196.272 354.442l7.25 12.557 139.339-80.45-7.25-12.557-139.339 80.45z"
  })), _path8 || (_path8 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M369.5 297.9c-9.6 16.7-31 22.4-47.7 12.8-16.7-9.6-22.4-31-12.8-47.7 9.6-16.7 31-22.4 47.7-12.8 16.8 9.7 22.5 31 12.8 47.7zM90.9 137c-9.6 16.7-31 22.4-47.7 12.8-16.7-9.6-22.4-31-12.8-47.7 9.6-16.7 31-22.4 47.7-12.8 16.7 9.7 22.4 31 12.8 47.7zM30.5 297.9c-9.6-16.7-3.9-38 12.8-47.7 16.7-9.6 38-3.9 47.7 12.8 9.6 16.7 3.9 38-12.8 47.7-16.8 9.6-38.1 3.9-47.7-12.8zM309.1 137c-9.6-16.7-3.9-38 12.8-47.7 16.7-9.6 38-3.9 47.7 12.8 9.6 16.7 3.9 38-12.8 47.7-16.7 9.6-38.1 3.9-47.7-12.8zM200 395.8c-19.3 0-34.9-15.6-34.9-34.9 0-19.3 15.6-34.9 34.9-34.9 19.3 0 34.9 15.6 34.9 34.9 0 19.2-15.6 34.9-34.9 34.9zM200 74c-19.3 0-34.9-15.6-34.9-34.9 0-19.3 15.6-34.9 34.9-34.9 19.3 0 34.9 15.6 34.9 34.9 0 19.3-15.6 34.9-34.9 34.9z"
  })));
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgGraphql);

/***/ }),
/* 12 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgKotlin(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M24 24H0V0h24L12 12z"
  })));
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgKotlin);

/***/ }),
/* 13 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgOdyssey(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 20"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    strokeLinejoin: "round",
    d: "M23.13 7.3L12 .88.88 7.3h0L12 13.72 23.13 7.3z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    strokeLinecap: "round",
    d: "M.88 7.3v5.08m0 2v.72m3.58-5.72v5.44a1.09 1.09 0 00.54.94l4.81 2.78a4.37 4.37 0 004.34 0L19 15.76a1.08 1.08 0 00.55-.94V9.38"
  }))));
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgOdyssey);

/***/ }),
/* 14 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgReactLogo(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 492 437",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M491.3 218.5c0-32.5-40.7-63.3-103.1-82.4 14.4-63.6 8-114.2-20.2-130.4-6.5-3.8-14.1-5.6-22.4-5.6v22.3c4.6 0 8.3.9 11.4 2.6 13.6 7.8 19.5 37.5 14.9 75.7-1.1 9.4-2.9 19.3-5.1 29.4-19.6-4.8-41-8.5-63.5-10.9-13.5-18.5-27.5-35.3-41.6-50 32.6-30.3 63.2-46.9 84-46.9V0c-27.5 0-63.5 19.6-99.9 53.6C209.4 19.8 173.4.4 145.9.4v22.3c20.7 0 51.4 16.5 84 46.6-14 14.7-28 31.4-41.3 49.9-22.6 2.4-44 6.1-63.6 11-2.3-10-4-19.7-5.2-29-4.7-38.2 1.1-67.9 14.6-75.8 3-1.8 6.9-2.6 11.5-2.6V.5c-8.4 0-16 1.8-22.6 5.6-28.1 16.2-34.4 66.7-19.9 130.1C41.2 155.4.7 186.1.7 218.5c0 32.5 40.7 63.3 103.1 82.4-14.4 63.6-8 114.2 20.2 130.4 6.5 3.8 14.1 5.6 22.5 5.6 27.5 0 63.5-19.6 99.9-53.6 36.4 33.8 72.4 53.2 99.9 53.2 8.4 0 16-1.8 22.6-5.6 28.1-16.2 34.4-66.7 19.9-130.1 62-19.1 102.5-49.9 102.5-82.3zm-130.2-66.7c-3.7 12.9-8.3 26.2-13.5 39.5-4.1-8-8.4-16-13.1-24-4.6-8-9.5-15.8-14.4-23.4 14.2 2.1 27.9 4.7 41 7.9zm-45.8 106.5c-7.8 13.5-15.8 26.3-24.1 38.2-14.9 1.3-30 2-45.2 2-15.1 0-30.2-.7-45-1.9-8.3-11.9-16.4-24.6-24.2-38-7.6-13.1-14.5-26.4-20.8-39.8 6.2-13.4 13.2-26.8 20.7-39.9 7.8-13.5 15.8-26.3 24.1-38.2 14.9-1.3 30-2 45.2-2 15.1 0 30.2.7 45 1.9 8.3 11.9 16.4 24.6 24.2 38 7.6 13.1 14.5 26.4 20.8 39.8-6.3 13.4-13.2 26.8-20.7 39.9zm32.3-13c5.4 13.4 10 26.8 13.8 39.8-13.1 3.2-26.9 5.9-41.2 8 4.9-7.7 9.8-15.6 14.4-23.7 4.6-8 8.9-16.1 13-24.1zM246.2 352c-9.3-9.6-18.6-20.3-27.8-32 9 .4 18.2.7 27.5.7 9.4 0 18.7-.2 27.8-.7-9 11.7-18.3 22.4-27.5 32zm-74.4-58.9c-14.2-2.1-27.9-4.7-41-7.9 3.7-12.9 8.3-26.2 13.5-39.5 4.1 8 8.4 16 13.1 24 4.7 8 9.5 15.8 14.4 23.4zM245.7 85c9.3 9.6 18.6 20.3 27.8 32-9-.4-18.2-.7-27.5-.7-9.4 0-18.7.2-27.8.7 9-11.7 18.3-22.4 27.5-32zm-74 58.9c-4.9 7.7-9.8 15.6-14.4 23.7-4.6 8-8.9 16-13 24-5.4-13.4-10-26.8-13.8-39.8 13.1-3.1 26.9-5.8 41.2-7.9zM81.2 269.1c-35.4-15.1-58.3-34.9-58.3-50.6 0-15.7 22.9-35.6 58.3-50.6 8.6-3.7 18-7 27.7-10.1 5.7 19.6 13.2 40 22.5 60.9-9.2 20.8-16.6 41.1-22.2 60.6-9.9-3.1-19.3-6.5-28-10.2zM135 412c-13.6-7.8-19.5-37.5-14.9-75.7 1.1-9.4 2.9-19.3 5.1-29.4 19.6 4.8 41 8.5 63.5 10.9 13.5 18.5 27.5 35.3 41.6 50-32.6 30.3-63.2 46.9-84 46.9-4.5-.1-8.3-1-11.3-2.7zm237.2-76.2c4.7 38.2-1.1 67.9-14.6 75.8-3 1.8-6.9 2.6-11.5 2.6-20.7 0-51.4-16.5-84-46.6 14-14.7 28-31.4 41.3-49.9 22.6-2.4 44-6.1 63.6-11 2.3 10.1 4.1 19.8 5.2 29.1zm38.5-66.7c-8.6 3.7-18 7-27.7 10.1-5.7-19.6-13.2-40-22.5-60.9 9.2-20.8 16.6-41.1 22.2-60.6 9.9 3.1 19.3 6.5 28.1 10.2 35.4 15.1 58.3 34.9 58.3 50.6-.1 15.7-23 35.6-58.4 50.6z"
  })), _circle || (_circle = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    cx: 245.9,
    cy: 218.5,
    r: 45.7
  })));
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgReactLogo);

/***/ }),
/* 15 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgRoverLogo(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 140 140",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M67.375 25.049a4.375 4.375 0 015.716 2.368c7.625 18.411-1.375 35.557-20.59 44.744l-.001 45.963 18.247.002a13.09 13.09 0 01-.743-4.066l-.004-.31v-4.375c0-7.145 5.71-12.957 12.815-13.121l.31-.004h12.412l5.723-23.126.041-.196c1.707-7.7 9.136-12.765 16.958-11.495 7.824 1.27 13.27 8.426 12.444 16.324l-.037.321-3.801 27.475A17.5 17.5 0 01140 122.5c0 9.665-7.835 17.5-17.5 17.5-8.154 0-15.006-5.577-16.949-13.125H51.95C50.006 134.423 43.154 140 35 140c-9.665 0-17.5-7.835-17.5-17.5S25.335 105 35 105c3.188 0 6.176.852 8.75 2.341V75.537C24.757 81.165 7.604 75.11.333 57.551A4.375 4.375 0 012.7 51.835zM35 113.75a8.75 8.75 0 100 17.5 8.75 8.75 0 000-17.5zm91.875 1.172a8.75 8.75 0 10-8.75 15.156 8.75 8.75 0 008.75-15.156zm-17.01-40.192l-.093.422-6.563 26.524a4.375 4.375 0 01-4.032 3.319l-.215.005H83.126a4.375 4.375 0 00-4.37 4.163l-.005.212v4.375a4.375 4.375 0 004.163 4.37l.212.005h22.43a17.5 17.5 0 018.195-10.78l.347-.196a17.484 17.484 0 013.93-1.568l3.965-28.649a6.172 6.172 0 00-12.127-2.202zm-43.5-39.792L10.407 58.114l.047.078c6.786 10.906 20.007 13.538 35.232 7.41l.514-.21c15.442-6.396 23.13-17.716 20.186-30.366l-.021-.088zM42.674 19.434a4.375 4.375 0 01-6.26 6.11l-.163-.167a6.796 6.796 0 00-7.2-1.81l-.164.06-.143.067a6.796 6.796 0 00-3.815 6.11l.005.26a4.375 4.375 0 11-8.743.34 15.546 15.546 0 018.938-14.68l.316-.144.18-.075a15.546 15.546 0 0117.049 3.93zm7.784-11.381a4.375 4.375 0 11-6.054 6.317 20.032 20.032 0 00-20.79-4.332l-.298.113-.279.125a20.05 20.05 0 00-11.65 17.384l-.013.39a4.375 4.375 0 11-8.748-.193 28.8 28.8 0 0116.866-25.58l.398-.179.156-.064a28.782 28.782 0 0130.412 6.019z"
  })));
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgRoverLogo);

/***/ }),
/* 16 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgSatellite3(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M11.267 6.973a4.5 4.5 0 000 9 .75.75 0 00.53-.22l3.75-3.75a.75.75 0 00.22-.53 4.5 4.5 0 00-4.5-4.5zm.176 1.505a3 3 0 012.803 2.645l.005.054-3.28 3.28-.054-.005a3 3 0 01.35-5.98l.176.006zM16.57.66L14.448 2.78a2.251 2.251 0 000 3.181l2.122 2.121a2.249 2.249 0 003.182 0l2.12-2.121a2.25 2.25 0 000-3.182L19.753.66a2.25 2.25 0 00-3.182 0zm2.12 1.06l2.122 2.12a.75.75 0 010 1.06l-2.12 2.122a.75.75 0 01-1.06 0l-2.123-2.12a.75.75 0 010-1.06L17.63 1.72a.75.75 0 011.06 0zM2.78 14.655L.66 16.776a2.25 2.25 0 000 3.182l2.12 2.12a2.25 2.25 0 003.182 0l2.12-2.12a2.25 2.25 0 000-3.182l-2.12-2.12a2.25 2.25 0 00-3.182 0zm2.12 1.06l2.122 2.122a.75.75 0 010 1.06l-2.12 2.121a.75.75 0 01-1.06 0l-2.122-2.12a.75.75 0 010-1.061l2.12-2.121a.75.75 0 011.06 0z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M6.493 6.7a.75.75 0 01.977-.073l.084.072 1.59 1.591a.75.75 0 01-.976 1.133l-.084-.072-1.59-1.591a.75.75 0 010-1.06zM16.263 13.504a.75.75 0 011.413.503 6.015 6.015 0 01-3.642 3.649.75.75 0 01-.505-1.413 4.515 4.515 0 002.734-2.739z"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M20.177 12.656l.101.01a.75.75 0 01.612.867 9.006 9.006 0 01-7.34 7.34.75.75 0 01-.256-1.479 7.506 7.506 0 006.117-6.116.75.75 0 01.766-.622z"
  })), _path4 || (_path4 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M23.294 11.908A.75.75 0 0124 12.7a12 12 0 01-11.466 11.292.75.75 0 11-.065-1.499 10.5 10.5 0 0010.034-9.88.75.75 0 01.792-.705z"
  })));
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgSatellite3);

/***/ }),
/* 17 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgSchema(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M21 0a3 3 0 11-1.523 5.585l-2.308 2.309A4.48 4.48 0 0118 10.5c0 .576-.108 1.127-.306 1.633l1.346 1.345a3 3 0 11-.865 1.258l-1.281-1.281a4.494 4.494 0 01-2.643 1.483v3.157a3 3 0 11-1.501 0v-3.157a4.476 4.476 0 01-1.857-.77l-5.308 5.308a3 3 0 11-1.06-1.06l5.307-5.309a4.514 4.514 0 01-.719-3.614L5.757 7.48a3 3 0 11.83-1.252l3.11 1.866a4.497 4.497 0 016.411-1.262l2.307-2.308A3 3 0 0121 0zm-7.5 19.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM3 19.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm18-5.25a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM13.5 7.5a3 3 0 00-2.15 5.093.17.17 0 01.031.026l.025.03a3 3 0 004.215-4.268l-.013-.016A2.99 2.99 0 0013.5 7.5zM3.75 3.75a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM21 1.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3z"
  })));
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgSchema);

/***/ }),
/* 18 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "generateSource": () => (/* binding */ generateSource),
/* harmony export */   "upperCaseFirstLetter": () => (/* binding */ upperCaseFirstLetter)
/* harmony export */ });
/* harmony import */ var _components_Header__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19);
/* harmony import */ var _components_Item__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _algolia_autocomplete_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21);
/* harmony import */ var _algolia_autocomplete_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_algolia_autocomplete_js__WEBPACK_IMPORTED_MODULE_3__);




var generateSource = function generateSource(_ref) {
  var isTopSource = _ref.isTopSource,
      sourceId = _ref.sourceId,
      indexName = _ref.indexName,
      searchClient = _ref.searchClient,
      _ref$hitsPerPage = _ref.hitsPerPage,
      hitsPerPage = _ref$hitsPerPage === void 0 ? 8 : _ref$hitsPerPage,
      _ref$isQuerySuggestio = _ref.isQuerySuggestion,
      isQuerySuggestion = _ref$isQuerySuggestio === void 0 ? false : _ref$isQuerySuggestio,
      headerTitle = _ref.headerTitle,
      optionalFilters = _ref.optionalFilters,
      isExternal = _ref.isExternal,
      _ref$transformRespons = _ref.transformResponse,
      transformResponse = _ref$transformRespons === void 0 ? function (_ref2) {
    var hits = _ref2.hits;
    return hits;
  } : _ref$transformRespons;
  return {
    sourceId: sourceId,
    getItems: function getItems(_ref3) {
      var query = _ref3.query;
      return (0,_algolia_autocomplete_js__WEBPACK_IMPORTED_MODULE_3__.getAlgoliaResults)({
        searchClient: searchClient,
        transformResponse: transformResponse,
        queries: [{
          indexName: indexName,
          query: query,
          params: {
            hitsPerPage: hitsPerPage,
            optionalFilters: optionalFilters,
            clickAnalytics: true
          }
        }]
      });
    },
    getItemUrl: function getItemUrl(_ref4) {
      var item = _ref4.item;
      return item.url;
    },
    onActive: function onActive(_ref5) {
      var item = _ref5.item,
          setContext = _ref5.setContext;
      setContext({
        preview: item
      });
    },
    onSelect: function onSelect(_ref6) {
      var item = _ref6.item,
          setQuery = _ref6.setQuery,
          setIsOpen = _ref6.setIsOpen,
          refresh = _ref6.refresh;

      // temporary solution to make updated query persist in search bar input
      // https://github.com/algolia/autocomplete/issues/636
      if (isQuerySuggestion) {
        setTimeout(function () {
          setQuery("".concat(item.query, " "));
          refresh();
        }, 100);
        setIsOpen(true);
      } else {
        // HACK: remove algolia detached class when the page changes
        document.body.classList.remove('aa-Detached');
      }
    },
    templates: {
      // eslint-disable-next-line react/prop-types
      header: function header(_ref7) {
        var items = _ref7.items;
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement((react__WEBPACK_IMPORTED_MODULE_2___default().Fragment), null, items.length > 0 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_components_Header__WEBPACK_IMPORTED_MODULE_0__["default"] // eslint-disable-next-line react/prop-types
        , {
          itemsLength: items.length,
          isExternal: isExternal,
          title: isQuerySuggestion ? "Can't find what you're looking for?" : headerTitle
        }));
      },
      // eslint-disable-next-line react/prop-types
      item: function item(_ref8) {
        var item = _ref8.item,
            components = _ref8.components;
        return isQuerySuggestion ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
          className: "aa-QuerySuggestion"
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(components.ReverseHighlight, {
          hit: item,
          attribute: "query"
        })) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_components_Item__WEBPACK_IMPORTED_MODULE_1__["default"], {
          hit: item,
          components: components
        });
      },
      noResults: function noResults() {
        // only want to render this for one of the sources, not all 4
        return isTopSource && 'No results for this query.';
      }
    }
  };
};
var upperCaseFirstLetter = function upperCaseFirstLetter(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

/***/ }),
/* 19 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Header)
/* harmony export */ });
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);


function Header(_ref) {
  var title = _ref.title,
      itemsLength = _ref.itemsLength,
      isExternal = _ref.isExternal;

  if (itemsLength === 0) {
    return null;
  }

  var apolloIndexes = ['documentation', 'blog', 'odyssey'];
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement((react__WEBPACK_IMPORTED_MODULE_1___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", {
    className: "aa-SourceHeaderTitle"
  }, isExternal && apolloIndexes.includes(title.toLowerCase()) && 'Apollo ', title), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "aa-SourceHeaderLine"
  }));
}
Header.propTypes = {
  title: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),
  itemsLength: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().number),
  isExternal: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().bool)
};

/***/ }),
/* 20 */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Item)
/* harmony export */ });
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _DocsetIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);



function Item(_ref) {
  var hit = _ref.hit,
      components = _ref.components;
  var icon = hit.type === 'docs' ? hit.docset : hit.type;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("a", {
    className: "aa-ItemLink",
    href: hit.url
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "aa-ItemContent"
  }, icon && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(_DocsetIcon__WEBPACK_IMPORTED_MODULE_2__.DocsetIcon, {
    docset: icon
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "aa-ItemContentBody"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "aa-ItemContentTitle"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(components.Highlight, {
    hit: hit,
    attribute: "title"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "aa-ItemContentSnippet"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(components.Snippet, {
    hit: hit,
    attribute: hit.text ? 'text' : 'description'
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "aa-ItemContentEnterKey"
  }, "\u21B5")));
}
Item.propTypes = {
  hit: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().object.isRequired),
  components: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().object.isRequired)
};

/***/ }),
/* 21 */
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__21__;

/***/ }),
/* 22 */
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__22__;

/***/ }),
/* 23 */
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__23__;

/***/ }),
/* 24 */
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__24__;

/***/ })
/******/ 	]);
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
(() => {
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* reexport safe */ _components_Autocomplete__WEBPACK_IMPORTED_MODULE_0__["default"]),
/* harmony export */   "DocsetIcon": () => (/* reexport safe */ _components_DocsetIcon__WEBPACK_IMPORTED_MODULE_1__.DocsetIcon)
/* harmony export */ });
/* harmony import */ var _components_Autocomplete__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _components_DocsetIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6);


})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});